import React from 'react';
import {Text, TextProps} from 'react-native';

type IconProps = TextProps & {
  name: string;
  size?: number;
  color?: string;
};

/** Only "down" is used in this app — keep the shim tiny. */
const GLYPHS: Record<string, string> = {
  down: '▼',
};

export function AntDesign({name, size = 12, color = '#000', style, ...rest}: IconProps) {
  return (
    <Text {...rest} style={[{fontSize: size, color, lineHeight: size}, style]}>
      {GLYPHS[name] ?? '•'}
    </Text>
  );
}

export default AntDesign;
